import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateMessageDraftMutationVariables = Types.Exact<{
  input: Types.CreateMessageDraftInput;
}>;

export type CreateMessageDraftMutation = {
  __typename?: 'Mutation';
  createMessageDraft: { __typename?: 'MessageDraft'; id: string; eventId: string; messageBatchId: string; updatedAt: any; status: Types.MessageDraftStatus };
};

export type UpdateMessageDraftMutationVariables = Types.Exact<{
  input: Types.UpdateMessageDraftInput;
}>;

export type UpdateMessageDraftMutation = {
  __typename?: 'Mutation';
  updateMessageDraft: { __typename?: 'MessageDraft'; id: string; updatedAt: any; status: Types.MessageDraftStatus };
};

export type DeleteMessageDraftMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  eventId: Types.Scalars['ID'];
}>;

export type DeleteMessageDraftMutation = { __typename?: 'Mutation'; deleteMessageDraft: boolean };

export type SendMessageDraftBatchMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  messageBatchId: Types.Scalars['ID'];
}>;

export type SendMessageDraftBatchMutation = {
  __typename?: 'Mutation';
  sendMessageDraftBatch: {
    __typename?: 'SendMessageBatchResult';
    messageBatchId: string;
    sentEmails: number;
    sentSms: number;
    skippedEmails: number;
    skippedSms: number;
    quarantined: boolean;
  };
};

export type MessageDraftsByBatchQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  messageBatchId: Types.Scalars['ID'];
}>;

export type MessageDraftsByBatchQuery = {
  __typename?: 'Query';
  messageDraftsByBatch: Array<{
    __typename?: 'MessageDraft';
    id: string;
    eventId: string;
    channel: Types.MessageDraftChannel;
    messageBatchId: string;
    messagePayload: any;
    displayLabel: string;
    recipientType: Types.MessageDraftRecipientType;
    recipientIds: Array<string>;
    status: Types.MessageDraftStatus;
    scheduledAt?: any | null;
    updatedAt: any;
  }>;
};

export const CreateMessageDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMessageDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMessageDraftInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMessageDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateMessageDraftMutationFn = Apollo.MutationFunction<CreateMessageDraftMutation, CreateMessageDraftMutationVariables>;

/**
 * __useCreateMessageDraftMutation__
 *
 * To run a mutation, you first call `useCreateMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageDraftMutation, { data, loading, error }] = useCreateMessageDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMessageDraftMutation, CreateMessageDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<CreateMessageDraftMutation, CreateMessageDraftMutationVariables>(CreateMessageDraftDocument, baseOptions);
}
export type CreateMessageDraftMutationHookResult = ReturnType<typeof useCreateMessageDraftMutation>;
export type CreateMessageDraftMutationResult = Apollo.MutationResult<CreateMessageDraftMutation>;
export type CreateMessageDraftMutationOptions = Apollo.BaseMutationOptions<CreateMessageDraftMutation, CreateMessageDraftMutationVariables>;
export const UpdateMessageDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMessageDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateMessageDraftInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMessageDraft' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateMessageDraftMutationFn = Apollo.MutationFunction<UpdateMessageDraftMutation, UpdateMessageDraftMutationVariables>;

/**
 * __useUpdateMessageDraftMutation__
 *
 * To run a mutation, you first call `useUpdateMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageDraftMutation, { data, loading, error }] = useUpdateMessageDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMessageDraftMutation, UpdateMessageDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateMessageDraftMutation, UpdateMessageDraftMutationVariables>(UpdateMessageDraftDocument, baseOptions);
}
export type UpdateMessageDraftMutationHookResult = ReturnType<typeof useUpdateMessageDraftMutation>;
export type UpdateMessageDraftMutationResult = Apollo.MutationResult<UpdateMessageDraftMutation>;
export type UpdateMessageDraftMutationOptions = Apollo.BaseMutationOptions<UpdateMessageDraftMutation, UpdateMessageDraftMutationVariables>;
export const DeleteMessageDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMessageDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMessageDraft' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteMessageDraftMutationFn = Apollo.MutationFunction<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>;

/**
 * __useDeleteMessageDraftMutation__
 *
 * To run a mutation, you first call `useDeleteMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageDraftMutation, { data, loading, error }] = useDeleteMessageDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteMessageDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>(DeleteMessageDraftDocument, baseOptions);
}
export type DeleteMessageDraftMutationHookResult = ReturnType<typeof useDeleteMessageDraftMutation>;
export type DeleteMessageDraftMutationResult = Apollo.MutationResult<DeleteMessageDraftMutation>;
export type DeleteMessageDraftMutationOptions = Apollo.BaseMutationOptions<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>;
export const SendMessageDraftBatchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMessageDraftBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessageDraftBatch' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'messageBatchId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentEmails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentSms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skippedEmails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'skippedSms' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quarantined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendMessageDraftBatchMutationFn = Apollo.MutationFunction<SendMessageDraftBatchMutation, SendMessageDraftBatchMutationVariables>;

/**
 * __useSendMessageDraftBatchMutation__
 *
 * To run a mutation, you first call `useSendMessageDraftBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageDraftBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageDraftBatchMutation, { data, loading, error }] = useSendMessageDraftBatchMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageBatchId: // value for 'messageBatchId'
 *   },
 * });
 */
export function useSendMessageDraftBatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendMessageDraftBatchMutation, SendMessageDraftBatchMutationVariables>) {
  return ApolloReactHooks.useMutation<SendMessageDraftBatchMutation, SendMessageDraftBatchMutationVariables>(SendMessageDraftBatchDocument, baseOptions);
}
export type SendMessageDraftBatchMutationHookResult = ReturnType<typeof useSendMessageDraftBatchMutation>;
export type SendMessageDraftBatchMutationResult = Apollo.MutationResult<SendMessageDraftBatchMutation>;
export type SendMessageDraftBatchMutationOptions = Apollo.BaseMutationOptions<SendMessageDraftBatchMutation, SendMessageDraftBatchMutationVariables>;
export const MessageDraftsByBatchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageDraftsByBatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageDraftsByBatch' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'messageBatchId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'messageBatchId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messagePayload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMessageDraftsByBatchQuery__
 *
 * To run a query within a React component, call `useMessageDraftsByBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDraftsByBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDraftsByBatchQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      messageBatchId: // value for 'messageBatchId'
 *   },
 * });
 */
export function useMessageDraftsByBatchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageDraftsByBatchQuery, MessageDraftsByBatchQueryVariables>) {
  return ApolloReactHooks.useQuery<MessageDraftsByBatchQuery, MessageDraftsByBatchQueryVariables>(MessageDraftsByBatchDocument, baseOptions);
}
export function useMessageDraftsByBatchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageDraftsByBatchQuery, MessageDraftsByBatchQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MessageDraftsByBatchQuery, MessageDraftsByBatchQueryVariables>(MessageDraftsByBatchDocument, baseOptions);
}
export type MessageDraftsByBatchQueryHookResult = ReturnType<typeof useMessageDraftsByBatchQuery>;
export type MessageDraftsByBatchLazyQueryHookResult = ReturnType<typeof useMessageDraftsByBatchLazyQuery>;
export type MessageDraftsByBatchQueryResult = Apollo.QueryResult<MessageDraftsByBatchQuery, MessageDraftsByBatchQueryVariables>;
